import React, { useEffect, useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import PrevQuestionLink from '../prevQuestionLink/prevQuestionLink';
import Button from '../button/Button';
import moment from 'moment';

const Question4 = props => {
  const [errors, setErrors] = useState({
    dateOfBirth: false,
    dateOfDeath: false,
    deathBeforeBirth: false,
  });

  const changeDateValue = (event, setFunction, errName, length) => {
    if (event.target.value.length > length) {
      return;
    }
    clearError(errName);
    const val = event.target.value.replace(/\D/g, '');
    setFunction(val);
  };

  const clearError = errName => {
    const e2 = { ...errors };
    e2[errName] = false;
    setErrors(e2);
  };

  const isDateOfBirthValid = () => {
    return (
      props.dayOfBirth === null ||
      isNaN(props.dayOfBirth) ||
      props.monthOfBirth === null ||
      isNaN(props.monthOfBirth) ||
      props.yearOfBirth === null ||
      isNaN(props.yearOfBirth) ||
      props.yearOfBirth < 1900 ||
      (props.dayOfBirth !== null && props.monthOfBirth !== null && props.yearOfBirth !== null
        ? !moment(`${props.yearOfBirth}-${props.monthOfBirth}-${props.dayOfBirth}`).isValid() ||
          moment(`${props.yearOfBirth}-${props.monthOfBirth}-${props.dayOfBirth}`).isAfter(moment())
        : false)
    );
  };

  const isDateOfDeathValid = () => {
    return (
      props.dayOfDeath === null ||
      isNaN(props.dayOfDeath) ||
      props.monthOfDeath === null ||
      isNaN(props.monthOfDeath) ||
      props.yearOfDeath === null ||
      isNaN(props.yearOfDeath) ||
      props.yearOfDeath < 1900 ||
      (props.dayOfDeath !== null && props.monthOfDeath !== null && props.yearOfDeath !== null
        ? !moment(`${props.yearOfDeath}-${props.monthOfDeath}-${props.dayOfDeath}`).isValid() ||
          moment(`${props.yearOfDeath}-${props.monthOfDeath}-${props.dayOfDeath}`).isAfter(moment())
        : false)
    );
  };

  const isDeathBeforeBirth = () => {
    const birth = moment(`${props.yearOfBirth}-${props.monthOfBirth}-${props.dayOfBirth}`);
    const death = moment(`${props.yearOfDeath}-${props.monthOfDeath}-${props.dayOfDeath}`);
    return (
      birth.isValid() &&
      death.isValid() &&
      props.yearOfDeath > 1900 &&
      props.yearOfBirth > 1900 &&
      death.isBefore(birth)
    );
  };

  useEffect(() => {
    if (!props.deathEntered) return;
    const e2 = { ...errors };
    e2.dateOfDeath = isDateOfDeathValid();
    e2.deathBeforeBirth = isDeathBeforeBirth();
    setErrors(e2);
  }, [props.dayOfDeath, props.monthOfDeath, props.yearOfDeath, props.deathEntered]);

  useEffect(() => {
    if (!props.birthEntered) return;
    const e2 = { ...errors };
    e2.dateOfBirth = isDateOfBirthValid();
    setErrors(e2);
  }, [props.dayOfBirth, props.monthOfBirth, props.yearOfBirth, props.birthEntered]);

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <PrevQuestionLink
          setCurrentQuestion={props.setCurrentQuestion}
          prevQuestionIndex={3}
          errorState={props.errorState}
        />
        {!props.errorState ? <h3 className={`${styles.pageTitle}`}>Important dates</h3> : null}
        <div className={`col-md-12 row`}>
          <div className={`overflow-hidden`}>
            <div className={`nsw-form-label ${styles.nswFormLabel}`}>Date of birth</div>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfBirthDay`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Day
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfBirthDay'}
                name={'deceasedDateOfBirthDay'}
                className={`mr-3 nsw-form-input ${styles.nswFormInput}`}
                placeholder={'DD'}
                value={
                  props.dayOfBirth && props.dayOfBirth.length > 0 ? props.dayOfBirth : undefined
                }
                onChange={e => changeDateValue(e, props.setDayOfBirth, 'dateOfBirth', 2)}
                aria-invalid={`${errors.dateOfBirth ? 'true' : 'false'}`}
              />
            </div>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfBirthMonth`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Month
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfBirthMonth'}
                name={'deceasedDateOfBirthMonth'}
                className={`mr-3 nsw-form-input ${styles.nswFormInput}`}
                placeholder={'MM'}
                value={
                  props.monthOfBirth && props.monthOfBirth.length > 0
                    ? props.monthOfBirth
                    : undefined
                }
                onChange={e => changeDateValue(e, props.setMonthOfBirth, 'dateOfBirth', 2)}
                aria-invalid={`${errors.dateOfBirth ? 'true' : 'false'}`}
              />
            </div>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfBirthYear`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Year
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfBirthYear'}
                name={'deceasedDateOfBirthYear'}
                className={`nsw-form-input ${styles.nswFormInput} ${styles.lg}`}
                placeholder={'YYYY'}
                value={
                  props.yearOfBirth && props.yearOfBirth.length > 0 ? props.yearOfBirth : undefined
                }
                onChange={e => changeDateValue(e, props.setYearOfBirth, 'dateOfBirth', 4)}
                onBlur={() => {
                  props.setBirthEntered(true);
                }}
                aria-invalid={`${errors.dateOfBirth ? 'true' : 'false'}`}
              />
            </div>
          </div>
        </div>

        <div className={`col-md-12 row mt-5`}>
          <div className={`overflow-hidden`}>
            <h4 className={`nsw-form-label ${styles.nswFormLabel}`}>Date of death</h4>
            <p className={styles.deathDescriptor}>
              If there is a date range, enter the first date shown.
            </p>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfDeathDay`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Day
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfDeathDay'}
                name={'deceasedDateOfDeathDay'}
                className={`mr-3 nsw-form-input ${styles.nswFormInput}`}
                placeholder={'DD'}
                value={
                  props.dayOfDeath && props.dayOfDeath.length > 0 ? props.dayOfDeath : undefined
                }
                onChange={e => changeDateValue(e, props.setDayOfDeath, 'dateOfDeath', 2)}
                aria-invalid={`${errors.dateOfDeath || errors.deathBeforeBirth ? 'true' : 'false'}`}
              />
            </div>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfDeathMonth`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Month
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfDeathMonth'}
                name={'deceasedDateOfDeathMonth'}
                className={`mr-3 nsw-form-input ${styles.nswFormInput}`}
                placeholder={'MM'}
                value={
                  props.monthOfDeath && props.monthOfDeath.length > 0
                    ? props.monthOfDeath
                    : undefined
                }
                onChange={e => changeDateValue(e, props.setMonthOfDeath, 'dateOfDeath', 2)}
                aria-invalid={`${errors.dateOfDeath || errors.deathBeforeBirth ? 'true' : 'false'}`}
              />
            </div>
            <div className={`float-left`}>
              <label
                for={`deceasedDateOfDeathYear`}
                className={`nsw-form-label d-block ${styles.nswFormSubLabel} ${styles.dBlock}`}
              >
                Year
              </label>
              <input
                translate="no"
                type="text"
                inputmode="decimal"
                id={'deceasedDateOfDeathYear'}
                name={'deceasedDateOfDeathYear'}
                className={`mr-3 nsw-form-input ${styles.nswFormInput} ${styles.lg}`}
                placeholder={'YYYY'}
                value={
                  props.yearOfDeath && props.yearOfDeath.length > 0 ? props.yearOfDeath : undefined
                }
                onChange={e => changeDateValue(e, props.setYearOfDeath, 'dateOfDeath', 4)}
                onBlur={() => {
                  props.setDeathEntered(true);
                }}
                aria-invalid={`${errors.dateOfDeath || errors.deathBeforeBirth ? 'true' : 'false'}`}
              />
            </div>
          </div>
        </div>

        <div className={styles.btnWrap}>
          <Button
            disabled={isDateOfDeathValid() || isDateOfBirthValid()}
            onClick={() => {
              props.validateDeceasedData(5);
            }}
          >
            {props.errorState ? 'Try again' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question4;
